import { render } from "./SmartboxInstallModal.vue?vue&type=template&id=5fbcfaf4"
import script from "./SmartboxInstallModal.vue?vue&type=script&lang=js"
export * from "./SmartboxInstallModal.vue?vue&type=script&lang=js"
script.render = render

export default script